<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>賦能-Solution</h2>
            <h2 style="padding-top: 10px;">解決方案</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<section class="features-area ptb-100">
    <div class="container" style="max-width: 90%;">

        <div class="overview-box" style="justify-content:space-evenly;">
            <div class="content">
                <h3 style="color: #2781bd;">整體評估 • 區塊執行</h3>
                <p style="color: black;">數位轉型並不是單一事件，它既是一段旅程，又是一個目標，但最重要的是，它需要清晰的路線圖和策略，並具備足夠空間進行調整彈性與適用性，許多經營管理者面臨的挑戰是為了要達到目標，先要知道他們要去哪裡? 要到達那裡需要什麼?以及如何評估他們執行時的風險？</p>
            </div>

            <img src="assets/img/solutions/pic_11.jpg" class="pic11" alt="image">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/3.png" alt="image">
            </div> -->
        </div>
    </div>
</section>

<!-- Start Services Area -->
<section class="services-area">
    <div class="container solutions-container">
        <div class="row">
            <div class="col-6 col-lg-4 col-md-6 col-sm-6">
                <a href="/solution-details?info=企業資源規劃 ERP 與 數位核心 Digital Platform">
                    <div class="single-services-box">
                        <div class="icon">
                            <img src="assets/img/solutions/icon_pic_4a.png" alt="image">
                        </div>
                        <h3>企業資源規劃與數位核心</h3>
                    </div>
                </a>
            </div>

            <div class="col-6 col-lg-4 col-md-6 col-sm-6">
                <a href="/solution-details?info=商業智慧與預測分析BI and AI">
                    <div class="single-services-box">
                        <div class="icon">
                            <img src="assets/img/solutions/icon_pic_5a.png" alt="image">
                        </div>
                        <h3>商業智慧與預測分析BI & AI</h3>
                    </div>
                </a>
            </div>

            <div class="col-6 col-lg-4 col-md-6 col-sm-6">
                <a href="/solution-details?info=顧客管理 CRM 與客戶體驗 CX">
                    <div class="single-services-box">
                        <div class="icon">
                            <img src="assets/img/solutions/icon_pic_6a.png" alt="image">
                        </div>
                        <h3>顧客管理 CRM 與客戶體驗 CX</h3>
                    </div>
                </a>
            </div>

            <div class="col-6 col-lg-6 col-md-6 col-sm-6">
                <!-- <a href="/coming-soon"> -->
                <a href="/solution-details?info=企業防疫營運不中斷戰術">
                    <!-- <a href="/solution-details?info=資料庫與資料管理DB & DW"> -->
                    <div class="single-services-box">
                        <div class="icon">
                            <img src="assets/img/solutions/icon_pic_7a.png" alt="image">
                        </div>
                        <h3>企業防疫營運不中斷戰術</h3>
                    </div>
                </a>
            </div>

            <div class="col-6 col-lg-6 col-md-6 col-sm-6">
                <!-- <a href="/coming-soon"> -->
                <a href="/NCour">
                    <!-- <a href="/solution-details?info=資料庫與資料管理DB & DW"> -->
                    <div class="single-services-box">
                        <div class="icon">
                            <img src="assets/img/solutions/icon_pic_8a.png" alt="image">
                        </div>
                        <h3>N-Cour 永續淨零平台</h3>
                    </div>
                </a>
            </div>

            <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/augmented-reality.png" alt="image">
                    </div>
                    <h3><a href="#">Virtual Reality</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/deep.png" alt="image">
                    </div>
                    <h3><a href="#">Deep Learning</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div> -->

            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a href="#" class="prev page-numbers"><i class="fas fa-angle-double-left"></i></a>
                    <a href="#" class="page-numbers">1</a>
                    <span class="page-numbers current" aria-current="page">2</span>
                    <a href="#" class="page-numbers">3</a>
                    <a href="#" class="page-numbers">4</a>
                    <a href="#" class="next page-numbers"><i class="fas fa-angle-double-right"></i></a>
                </div>
            </div> -->
        </div>
    </div>

    <!-- <div class="services-shape"><img src="assets/img/services-shape.png" alt="image"></div> -->
</section>

<section class="features-area ptb-100" style="padding-top: 0px;">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content:space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/3.png" alt="image">
            </div> -->
            <img class="pic12" src="assets/img/solutions/pic_12.jpg" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">全面考量 • 專業把關</h3>
                <p style="color: black;">碩達系統提供企業級的解決方案，因應不同產業、規模、環境、預算提供最適方案，從中小企業到大型跨國集團、教育單位、公部門，依照需求與屬性進行建議規劃，為企業轉型賦能。</p>
            </div>
        </div>
    </div>
</section>
<!-- End Services Area -->